export default __webpack_public_path__ + "images/jp_end.png";